import { ApiSmpGpt } from "@smp/api";
import { Await } from "@smp/utils";
import { useInfiniteQuery } from "react-query";
import { UseInfiniteQueryOptions } from "react-query/types/react/types";

import { useContextApp } from "@/screens/app/context/app";

type Response = Await<ReturnType<typeof ApiSmpGpt.Agent.list>>;

const KEY_GPT_AGENT_LIST = "gpt.agent.list";

export const useQueryGptAgentList = (
  options?: Omit<
    UseInfiniteQueryOptions<Response>,
    "queryKey" | "queryFn" | "getNextPageParam"
  >,
) => {
  const {
    state: { organizationId },
  } = useContextApp();

  return useInfiniteQuery<Response>(
    [KEY_GPT_AGENT_LIST, { organizationId }],
    ({ pageParam }) => ApiSmpGpt.Agent.list(pageParam),
    {
      getNextPageParam: (response) =>
        response.next
          ? Object.fromEntries(new URL(response.next).searchParams)
          : undefined,
      ...options,
    },
  );
};

useQueryGptAgentList.KEY = KEY_GPT_AGENT_LIST;
